import React from "react";

const ScreenHeader = ({ children }) => {
  return <div className=" border-b border-gray-700 pb-5 my-5">{children}</div>;
};

export default ScreenHeader;
